import * as React from "react";
import {highlightMatch} from "../../utils/researchUtil";

export interface IHighlightTextProps {
    text: string;
    search: string;
}

export const HighlightText: React.FunctionComponent<IHighlightTextProps> = ({text, search}) => {
    if (!search || !text) return <>{text}</>;

    const parts = highlightMatch(text, search);
    return (
        <>
            {parts.map((part, i) =>
                part.highlighted
                    ? <mark key={i}>{part.text}</mark>
                    : <React.Fragment key={i}>{part.text}</React.Fragment>
            )}
        </>
    );
};
